import axios from 'axios';
import APIURL from '../Main/apiurl';

let requestQueue = [];
let latestRequestId = null;


const axiosInstance = axios.create({
    baseURL: APIURL,
    timeout: 30000,
});

axiosInstance.interceptors.request.use(
    (config) => {
        const requestId = `${Date.now()}-${Math.random().toString(36).substr(2, 5)}`;

        config.headers['X-Request-ID'] = requestId;
        latestRequestId = requestId;

        requestQueue.push(requestId);

        const token = localStorage.getItem("user");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        const requestId = response.config.headers['X-Request-ID'];

        if (requestId !== latestRequestId) {
            return Promise.reject({
                isOutdated: true,
                message: 'Outdated response - newer request was made'
            });
        }

        console.log("not a delay");

        requestQueue = requestQueue.filter(id => id !== requestId);

        return response;
    },
    (error) => {
        if (error.isOutdated) {
            console.log('Ignoring outdated response');
            return Promise.resolve({ data: { status: 'outdated', message: 'Request superseded' } });
        }

        const requestId = error.config?.headers?.['X-Request-ID'];
        if (requestId) {
            requestQueue = requestQueue.filter(id => id !== requestId);
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;